import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);
const routes = [
   {
      path: "/",
      name: "home",
      component: Home,
   },

   {
      path: "/surah/:nomor",
      name: "surah",
      component: () => import("../views/Surah.vue"),
   },
   {
      path: "/audio",
      name: "audio",
      component: () => import("../views/Murottal.vue"),
   },
   {
      path: "/doa",
      name: "doa",
      component: () => import("../views/Doa.vue"),
   },
   {
      path: "/doa/:id",
      name: "doa-detail",
      component: () => import("../views/DetailDoa.vue"),
   },
];

const router = new VueRouter({
   linkActiveClass: "active",
   linkExactActiveClass: "exact-active",
   mode: "history",
   base: process.env.BASE_URL,
   routes,
});

export default router;
